import { httpClient as http } from '@/utils/http'

// API基础路径
const API_BASE = '/mdm/terminal'

// 基础分页请求
export interface PageRequest {
  pageNum: number
  pageSize: number
}

// 分页结果
export interface PageResultVO<T> {
  records: T[]
  total: number
  pageNum: number
  pageSize: number
}

// 码头分页查询请求
export interface TerminalPageRequest extends PageRequest {
  tenantId?: string
  terminalCode?: string
  terminalNameCn?: string
  terminalNameEn?: string
  portCode?: string
  portName?: string
  enabled?: number
  keyword?: string
}

// 码头列表项视图对象
export interface TerminalListVO {
  id: string
  tenantId?: string
  terminalCode: string
  terminalNameCn: string
  terminalNameEn: string
  portCode: string
  portName?: string
  terminalLink?: string
  enabled: number
  isPlatformData?: boolean
  dateCreated?: string
  dateModified?: string
}

// 码头详情视图对象
export interface TerminalVO {
  id: string
  tenantId?: string
  terminalCode: string
  terminalNameCn: string
  terminalNameEn: string
  portCode: string
  portName?: string
  terminalLink?: string
  address?: string
  description?: string
  enabled: number
  isPlatformData?: boolean
}

// 码头保存请求
export interface TerminalSaveRequest {
  id?: string
  tenantId?: string
  terminalCode: string
  terminalNameCn: string
  terminalNameEn: string
  portCode: string
  portName?: string
  terminalLink?: string
  address?: string
  description?: string
  enabled?: number
}

// 模糊搜索请求
export interface FuzzySearchRequest {
  keyword: string
  enabled?: number
  tenantId?: string
}

// 批量删除请求
export interface BatchDeleteRequest {
  ids: string[]
}

// 批量状态更新请求
export interface BatchUpdateStatusRequest {
  ids: string[]
  enabled: number
}

// 批量关联请求
export interface BatchAssociateRequest {
  platformIds: string[]
}

// 批量解除关联请求
export interface BatchDisassociateRequest {
  associationIds?: string[]
  platformIds?: string[]
}

// 码头API
export const terminalApi = {
  // 分页查询码头列表
  page: (params: TerminalPageRequest) => {
    return http.post<PageResultVO<TerminalListVO>>(`${API_BASE}/queryPage`, params)
  },

  // 查询码头列表
  list: (params: TerminalPageRequest) => {
    return http.post<TerminalListVO[]>(`${API_BASE}/queryList`, params)
  },

  // 模糊搜索码头
  search: (params: FuzzySearchRequest) => {
    return http.post<TerminalListVO[]>(`${API_BASE}/search`, params)
  },

  // 根据ID获取码头详情
  getById: (params: { id: string }) => {
    return http.post<TerminalVO>(`${API_BASE}/getById`, params)
  },

  // 根据码头代码查询
  getByCode: (params: { code: string }) => {
    return http.post<TerminalVO>(`${API_BASE}/getByCode`, params)
  },

  // 保存码头（新增或更新）
  save: (params: TerminalSaveRequest) => {
    return http.post<boolean>(`${API_BASE}/save`, params)
  },

  // 删除码头
  delete: (params: BatchDeleteRequest) => {
    return http.post<boolean>(`${API_BASE}/delete`, params)
  },

  // 更新状态
  updateStatus: (params: BatchUpdateStatusRequest) => {
    return http.post<boolean>(`${API_BASE}/updateStatus`, params)
  },

  // 批量更新状态
  batchUpdateStatus: (params: BatchUpdateStatusRequest) => {
    return http.post<boolean>(`${API_BASE}/batchUpdateStatus`, params)
  },

  // 查询启用状态的码头列表
  queryEnabled: (params: TerminalPageRequest) => {
    return http.post<TerminalListVO[]>(`${API_BASE}/queryEnabled`, params)
  },

  // 查询可关联的平台码头（分页）
  queryPlatformPage: (params: TerminalPageRequest) => {
    return http.post<PageResultVO<TerminalListVO>>(`${API_BASE}/queryPlatformPage`, params)
  },

  // 查询可关联的平台码头（列表）
  queryPlatformList: (params: TerminalPageRequest) => {
    return http.post<TerminalListVO[]>(`${API_BASE}/queryPlatformList`, params)
  },

  // 批量关联平台码头
  batchAssociate: (params: BatchAssociateRequest) => {
    return http.post<boolean>(`${API_BASE}/batchAssociate`, params)
  },

  // 批量解除关联平台码头
  batchDisassociate: (params: BatchDisassociateRequest) => {
    return http.post<boolean>(`${API_BASE}/batchDisassociate`, params)
  }
}
